import { type SamplingJobValidation, SamplingJobValidationStatus } from './sampling-job.type.ts';
import { type SamplingJob, SamplingJobStatus } from '../services/api.types.ts';

const STATUS_DAY_THRESHOLD = 14;

export const getSamplingJobValidation = (job: SamplingJob): SamplingJobValidation => {
  if (!job.plannedDate) {
    return {
      status: SamplingJobValidationStatus.warn,
      title: 'No Planned Date',
      description: 'This job has no planned date. Unscheduled jobs are excluded from board metrics and reporting.',
    };
  }

  if (job.statusId === SamplingJobStatus.SamplingInProgress && job.samplerIds.length === 0) {
    return {
      status: SamplingJobValidationStatus.warn,
      title: 'No Samplers Assigned',
      description: 'This job is marked as sampling in progress, but no samplers are assigned.',
    };
  }

  if (job.statusId < SamplingJobStatus.SamplingComplete && job.daysInStatus > STATUS_DAY_THRESHOLD) {
    return {
      status: SamplingJobValidationStatus.warn,
      title: 'Status Inactivity Warning',
      description: `This job has remained in its current status for more than ${STATUS_DAY_THRESHOLD} days without progress.`,
    };
  }

  return { status: SamplingJobValidationStatus.okay, title: 'No Issues Found' };
};
